/* EDG Arctic Circle guided builder — shared standard + Fi flow. */
(function () {
  'use strict';

  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
  const pretty = n => Number(Number(n).toFixed(3)).toString();
  const guided = () => new URLSearchParams(location.search || '').get('edg_guided') === '1';
  const show = (el, yes) => { if (el) el.hidden = !yes; };
  const setText = (root, sel, value) => { const el = $(root, sel); if (el) el.textContent = value || ''; };

  function nativeContainer(optionHandle) {
    const selector = '[data-option-name="' + optionHandle + '"]';
    return document.querySelector('.variant-selects-main ' + selector) || document.querySelector(selector);
  }

  function applyNative(optionHandle, value) {
    const container = nativeContainer(optionHandle);
    if (!container) return false;
    const radio = Array.from(container.querySelectorAll('input[type="radio"]')).find(el => el.value === value);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const select = container.querySelector('select');
    if (!select) return false;
    const index = Array.from(select.options).findIndex(option => option.value === value || option.textContent.trim() === value);
    if (index < 0) return false;
    select.selectedIndex = index;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function nativeSelected(optionHandle) {
    const container = nativeContainer(optionHandle);
    if (!container) return '';
    const radio = container.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;
    const select = container.querySelector('select');
    return select ? select.value : '';
  }

  function nativeVariantId(root) {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(form => !root.contains(form));
    const preferred = forms.find(form => String(form.getAttribute('id') || '').indexOf('product-form-') === 0 && form.querySelector('input[name="id"]')) || forms.find(form => form.querySelector('input[name="id"]'));
    const input = preferred && preferred.querySelector('input[name="id"]');
    return input && input.value ? Number(input.value) : null;
  }

  function setStatus(root, message, state) {
    const node = $(root, '[data-status]');
    if (!node) return;
    node.textContent = message || '';
    if (state) node.dataset.state = state; else delete node.dataset.state;
  }

  function selectButton(button, container, selector) {
    if (!container) return;
    $$(container, selector || 'button').forEach(el => {
      const selected = el === button;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function parseRange(label) {
    const match = String(label || '').match(/([0-9]+(?:\.[0-9]+)?)\s*[-–]\s*([0-9]+(?:\.[0-9]+)?)/);
    return match ? { min: Number(match[1]), max: Number(match[2]) } : null;
  }

  function measurements(root) {
    return { neck: Number($(root, '[data-neck]').value), head: Number($(root, '[data-head]').value) };
  }

  function requiredOpening(root) {
    const m = measurements(root);
    return m.neck > 0 && m.head > 0 ? Math.max(m.neck, m.head) : null;
  }

  function recommendSize(root) {
    const required = requiredOpening(root);
    if (!required) return null;
    const buttons = $$(root, '[data-size-choice]');
    const matches = buttons.map(button => ({ button, range: parseRange(button.dataset.nativeValue) }))
      .filter(item => item.range && required >= item.range.min && required <= item.range.max)
      .sort((a, b) => (b.range.min - a.range.min) || (b.range.max - a.range.max));
    if (matches.length) return { button: matches[0].button, overlap: matches.length > 1, custom: false, required };
    const custom = buttons.find(button => /custom/i.test(button.dataset.nativeValue || ''));
    return custom ? { button: custom, overlap: false, custom: true, required } : null;
  }

  function setStep(root, key, state) {
    const step = $(root, '[data-step="' + key + '"]');
    if (!step) return;
    step.classList.remove('is-active', 'is-complete', 'is-locked');
    step.classList.add('is-' + state);
    const header = $(step, '[data-edit-step]');
    if (header) {
      header.disabled = state === 'locked';
      header.setAttribute('aria-expanded', state === 'active' ? 'true' : 'false');
    }
    const progress = $(root, '[data-progress="' + key + '"]');
    if (progress) {
      progress.classList.toggle('is-active', state === 'active');
      progress.classList.toggle('is-complete', state === 'complete');
    }
  }

  function focusActiveStep(root) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      const step = $(root, '[data-step].is-active');
      if (!step) return;
      const header = $(step, '[data-edit-step]') || step;
      const sticky = document.querySelector('.section-header.is-sticky');
      const offset = 16 + (sticky ? Math.max(0, sticky.getBoundingClientRect().height) : 0);
      const top = Math.max(0, window.scrollY + header.getBoundingClientRect().top - offset);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top, behavior });
      if (header.focus) header.focus({ preventScroll: true });
    }));
  }

  function activateStep(root, key) {
    const order = ['fit', 'construction', 'color', 'addons', 'review'];
    const index = order.indexOf(key);
    order.forEach((name, i) => setStep(root, name, i < index ? 'complete' : (i === index ? 'active' : 'locked')));
  }

  function savedFiKind(value) {
    const v = String(value || '').toLowerCase();
    if (!v) return '';
    if (v.includes('mini')) return 'mini';
    if (v.includes('ultra')) return 'ultra';
    if (v.includes('2')) return '2';
    if (v.includes('3')) return '3';
    return '';
  }

  function fiWebbingSummary(root, value, width) {
    const model = String(value || '').replace(/\s*[-–—]\s*(?:3\/4|1)\s*inch\b/ig, '').trim();
    return [model, width ? (root.dataset.webbingLabel || '[width]').replace('[width]', width) : ''].filter(Boolean).join(' · ');
  }

  function constructionWidth(root) {
    if (root.dataset.productFamily === 'arctic-standard') return root.dataset.webbingWidth || '';
    if (/Series 2/i.test(root.dataset.nativeFiSeries || '')) return root.dataset.webbingWidth || '';
    if (/3\/4 inch/i.test(root.dataset.nativeFiSeries || '')) return '3/4 inch';
    if (/1 inch/i.test(root.dataset.nativeFiSeries || '')) return '1 inch';
    return '';
  }

  function saveBuild(root, session) {
    if (!session) return;
    const m = measurements(root);
    if (session.saveMeasurement) {
      if (m.neck > 0) session.saveMeasurement('neck', pretty(m.neck));
      if (m.head > 0) session.saveMeasurement('head', pretty(m.head));
    }
    if (session.saveBuild) {
      session.saveBuild('arctic', {
        mode: root.dataset.productFamily === 'arctic-fi' ? 'fi' : 'standard',
        productHandle: root.dataset.productHandle || '',
        neck: m.neck > 0 ? pretty(m.neck) : '',
        head: m.head > 0 ? pretty(m.head) : '',
        requiredOpening: requiredOpening(root) ? pretty(requiredOpening(root)) : '',
        size: root.dataset.sizeValue || '',
        webbingWidth: constructionWidth(root),
        fiSeries: root.dataset.savedFiSeries || '',
        nativeFiSeries: root.dataset.nativeFiSeries || '',
        color: root.dataset.colorValue || '',
        guided: guided()
      });
    }
  }

  function updateFit(root, session) {
    if (window.EDGSizing && window.EDGSizing.update(root, session)) return;
    const result = $(root, '[data-fit-result]');
    const sizeArea = $(root, '[data-size-result]');
    const required = requiredOpening(root);
    $$(root, '[data-size-choice]').forEach(button => { button.hidden = true; button.classList.remove('is-selected'); });
    root.dataset.sizeValue = '';
    if (!required) {
      show(result, false); show(sizeArea, false); saveBuild(root, session); return;
    }
    const m = measurements(root);
    show(result, true);
    setText(root, '[data-fit-neck]', pretty(m.neck) + ' in neck');
    setText(root, '[data-fit-head]', pretty(m.head) + ' in widest head');
    setText(root, '[data-opening]', pretty(required) + ' in');

    const recommendation = recommendSize(root);
    if (!recommendation) { show(sizeArea, false); saveBuild(root, session); return; }
    recommendation.button.hidden = false;
    show(sizeArea, true);
    setText(root, '[data-size-result-label]', recommendation.button.dataset.nativeValue);
    if (recommendation.custom) setText(root, '[data-size-result-note]', 'The required opening falls outside the published standard ranges. Custom sizing is the correct next path.');
    else if (recommendation.overlap) setText(root, '[data-size-result-note]', 'This measurement sits in an overlap. EDG recommends the larger matching published size.');
    else setText(root, '[data-size-result-note]', 'This is the published size range that contains the required opening.');
    saveBuild(root, session);
  }

  function prepareFi(root, session) {
    const dog = !new URLSearchParams(location.search).has('edg_edit') && session && session.activeDog ? session.activeDog() : null;
    const savedFi = dog && dog.fiStatus === 'yes' ? dog.fiSeries : '';
    const kind = savedFiKind(savedFi);
    root.dataset.savedFiSeries = savedFi || '';
    if (kind === 'mini' || kind === 'ultra' || (dog && dog.fiStatus === 'no')) {
      location.replace('/products/arctic-circle-collar?edg_guided=1');
      return false;
    }
    const buttons = $$(root, '[data-fi-native-choice]');
    const question = $(root, '[data-fi-construction-question]');
    if (kind === '2') {
      const fi2 = buttons.find(button => /Series 2/i.test(button.dataset.nativeValue || ''));
      buttons.forEach(button => { button.hidden = button !== fi2; });
      if (fi2 && applyNative(fi2.dataset.nativeOption, fi2.dataset.nativeValue)) {
        root.dataset.nativeFiSeries = fi2.dataset.nativeValue;
        fi2.hidden = true;
        show($(root, '[data-fi2-width]'), true);
      }
      if (question) question.textContent = question.dataset.fiWidthPrompt.replace('[model]', savedFi);
    } else if (kind === '3') {
      buttons.forEach(button => { button.hidden = !/3\/3\+/i.test(button.dataset.nativeValue || ''); });
      if (question) question.textContent = question.dataset.fiWidthPrompt.replace('[model]', savedFi);
    } else {
      buttons.forEach(button => { button.hidden = false; });
      if (question) question.textContent = question.dataset.fiPrompt;
    }
    return true;
  }

  function filterColors(root) {
    const select = $(root, '[data-color-select]');
    if (!select) return;
    const width = constructionWidth(root);
    const native = nativeContainer(root.dataset.colorOption || 'color');
    Array.from(select.options).forEach(option => {
      if (!option.value) return;
      if (!option.dataset.originalLabel) option.dataset.originalLabel = option.textContent;
      const widthBlocked = /1 inch only/i.test(option.dataset.originalLabel) && width === '3/4 inch';
      let unavailable = false;
      if (native) {
        const radio = Array.from(native.querySelectorAll('input[type="radio"]')).find(el => el.value === option.value);
        if (radio) unavailable = radio.disabled || radio.dataset.available === 'false' || radio.classList.contains('disabled');
      }
      option.hidden = widthBlocked;
      option.disabled = widthBlocked || unavailable;
    });
    if (select.value && select.options[select.selectedIndex] && select.options[select.selectedIndex].disabled) {
      select.value = ''; root.dataset.colorValue = '';
    }
  }

  function constructionComplete(root, session, advance) {
    const isFi = root.dataset.productFamily === 'arctic-fi';
    const width = constructionWidth(root);
    if (!width) return false;
    if (isFi && !root.dataset.nativeFiSeries) return false;
    filterColors(root);
    const fiLabel = root.dataset.savedFiSeries || root.dataset.nativeFiSeries || 'Fi';
    setText(root, '[data-step-summary="construction"]', isFi ? fiWebbingSummary(root, fiLabel, width) : width);
    setStep(root, 'construction', advance ? 'complete' : 'active');
    setStep(root, 'color', advance ? 'active' : 'locked');
    setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
    saveBuild(root, session);
    if (advance) focusActiveStep(root);
    window.setTimeout(() => filterColors(root), 500);
    return true;
  }

  function updateReview(root) {
    const m = measurements(root);
    const isFi = root.dataset.productFamily === 'arctic-fi';
    setText(root, '[data-review-dog]', root.dataset.dogName || 'Your dog');
    setText(root, '[data-review-fit]', pretty(m.neck) + ' in neck · ' + pretty(m.head) + ' in head · ' + pretty(requiredOpening(root)) + ' in required opening');
    setText(root, '[data-review-size]', root.dataset.sizeValue || '');
    setText(root, '[data-review-construction]', isFi ? fiWebbingSummary(root, root.dataset.savedFiSeries || root.dataset.nativeFiSeries, constructionWidth(root)) : constructionWidth(root));
    setText(root, '[data-review-color]', root.dataset.colorValue || '');
  }

  function nativeSelectionsMatch(root) {
    if (nativeSelected(root.dataset.sizeOption || 'size') !== (root.dataset.sizeValue || '')) return false;
    if (nativeSelected(root.dataset.colorOption || 'color') !== (root.dataset.colorValue || '')) return false;
    if (root.dataset.productFamily === 'arctic-standard') return nativeSelected(root.dataset.widthOption || 'webbing-width') === (root.dataset.webbingWidth || '');
    return nativeSelected(root.dataset.fiOption || 'fi-series-see-images') === (root.dataset.nativeFiSeries || '');
  }

  function waitForNative(root, timeout) {
    return new Promise(resolve => {
      const start = Date.now();
      function check() {
        if (nativeSelectionsMatch(root) && nativeVariantId(root)) return resolve(true);
        if (Date.now() - start >= timeout) return resolve(false);
        setTimeout(check, 100);
      }
      check();
    });
  }

  async function addBuild(root, session) {
    if (window.EDGSizing && !window.EDGSizing.validate(root)) return;
    const required = requiredOpening(root);
    if ((!window.EDGSizing?.isKnown(root) && !required) || !root.dataset.sizeValue || !constructionWidth(root) || !root.dataset.colorValue) {
      setStatus(root, 'Complete fit, construction, and color before adding this collar.', 'error'); return;
    }
    const button = $(root, '[data-add-build]');
    button.disabled = true;
    setStatus(root, 'Checking the selected Arctic Circle…');
    const synced = window.EDGCheckoutIntegrity && await window.EDGCheckoutIntegrity.waitForExact(root, 4000);
    if (!synced) {
      button.disabled = false;
      setStatus(root, 'Eurus could not confirm the exact native Shopify variant. Re-select the last choice and try again.', 'error'); return;
    }
    const id = nativeVariantId(root);
    if (!id) { button.disabled = false; setStatus(root, 'That exact Arctic Circle combination is not currently available.', 'error'); return; }
    const m = measurements(root);
    const dog = !new URLSearchParams(location.search).has('edg_edit') && session && session.activeDog ? session.activeDog() : null;
    const props = {
      'Dog name': dog && dog.name ? dog.name : '',
      'Dog neck': pretty(m.neck) + ' in',
      'Widest head': pretty(m.head) + ' in',
      'Required opening': pretty(required) + ' in',
      'EDG guided size': root.dataset.sizeValue, 'Size selection': window.EDGSizing ? window.EDGSizing.method(root) : 'Size recommendation',
      'Webbing width': constructionWidth(root),
      'Color': root.dataset.colorValue,
      '_EDG Config Version': root.dataset.productFamily === 'arctic-fi' ? 'guided-fi-arctic-v1' : 'guided-standard-arctic-v1',
      '_EDG Entry Path': 'Guided selector'
    };
    if (root.dataset.productFamily === 'arctic-fi') {
      props['Fi setup'] = root.dataset.savedFiSeries || root.dataset.nativeFiSeries;
      props['Fi collar configuration'] = root.dataset.nativeFiSeries;
    }
    button.textContent = 'Adding collar…';
    try {
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      await window.EDGBuildEditor.submit(root, window.EDGBuildCommerce.withIdAnchor(root, { id, quantity: 1, properties: props }));
      saveBuild(root, session);
      setStatus(root, 'Collar added. Opening cart…');
      location.assign(base + 'cart');
    } catch (error) {
      button.disabled = false; button.textContent=window.EDGBuildEditor.label(root)||'Add this collar to cart';
      setStatus(root, error.message || 'Something prevented this collar from being added.', 'error');
    }
  }

  function reuseChosenColor(root, session) {
    const dog=session&&session.activeDog?session.activeDog():null;
    const chosen=root.dataset.preferredColor||(dog&&dog.preferredColor)||'';
    if(!chosen)return false;
    root.dataset.preferredColor=chosen;
    const select=$(root,'[data-color-select]');
    if(!select)return false;
    const normalize=value=>String(value||'').toLowerCase().replace(/\([^)]*\)/g,'').replace(/1[- ]inch styles/g,'').replace(/[^a-z]/g,'');
    const option=Array.from(select.options).find(item=>item.value&&normalize(item.value)===normalize(chosen));
    const stringsNode=document.querySelector('[data-edg-color-strings]');
    const strings=stringsNode?JSON.parse(stringsNode.textContent):{};
    if(!option||option.disabled||option.hidden){
      if(strings.unavailable)setStatus(root,strings.unavailable,'error');
      return false;
    }
    select.value=option.value;
    select.dispatchEvent(new Event('change',{bubbles:true}));
    if(typeof syncSwatches==='function')syncSwatches(root);
    if(root.dataset.colorValue===option.value){if(strings.saved)setStatus(root,strings.saved,'success');return true;}
    return false;
  }
  function init(root, session) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    if (window.EDGSizing) window.EDGSizing.mount(root, { fit: () => updateFit(root, session), review: () => updateReview(root), save: () => saveBuild(root, session), construction: () => constructionComplete(root, session, true) });
    if (!guided()) { show(root, false); return; }
    show(root, true);
    document.documentElement.classList.add('edg-arctic-guided-active');
    const dog = session.activeDog ? session.activeDog() : null;
    root.dataset.dogName = dog && dog.name ? dog.name : 'Your dog';
    root.dataset.savedFiSeries = dog && dog.fiStatus === 'yes' ? dog.fiSeries : '';
    const name = dog && dog.name ? dog.name : '';
    setText(root, '[data-builder-title]', root.dataset.layoutTitle);

    const sizeButton = $(root, '[data-size-choice]');
    const widthButton = $(root, '[data-width-choice]');
    const fiButton = $(root, '[data-fi-native-choice]');
    const colorOption = $(root, '[data-color-select] option[data-native-option]');
    root.dataset.sizeOption = sizeButton ? sizeButton.dataset.nativeOption : 'size';
    root.dataset.widthOption = widthButton ? widthButton.dataset.nativeOption : 'webbing-width';
    root.dataset.fiOption = fiButton ? fiButton.dataset.nativeOption : 'fi-series-see-images';
    root.dataset.colorOption = colorOption ? colorOption.dataset.nativeOption : 'color';

    if (root.dataset.productFamily === 'arctic-fi') {
      if (!prepareFi(root, session)) return;
    } else if (dog && dog.fiStatus === 'yes' && savedFiKind(dog.fiSeries) === '3') {
      const note = $(root, '[data-fi-context]');
      if (note) {
        note.hidden = false;
        note.innerHTML = '<strong>Saved Fi setup:</strong> ' + dog.fiSeries + '. For Fi integrated into the collar, <a href="/products/fi-arctic-circle-collar?edg_guided=1">switch to Fi Arctic Circle</a>. Continue here only if you want a standard Arctic Circle.';
      }
    }

    if (dog && dog.measurements) {
      const neck = Number(dog.measurements.neck), head = Number(dog.measurements.head);
      if (neck > 0) $(root, '[data-neck]').value = pretty(neck);
      if (head > 0) $(root, '[data-head]').value = pretty(head);
      updateFit(root, session);
    }

    $$(root, '[data-neck], [data-head]').forEach(input => {
      input.addEventListener('input', () => updateFit(root, session));
      input.addEventListener('change', () => updateFit(root, session));
    });

    $$(root, '[data-size-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) { setStatus(root, 'We could not apply that size to the Eurus selector.', 'error'); return; }
      selectButton(button, $(root, '[data-size-choices]'), '[data-size-choice]');
      root.dataset.sizeValue = button.dataset.nativeValue;
      setText(root, '[data-step-summary="fit"]', pretty(requiredOpening(root)) + ' in opening · ' + button.dataset.nativeValue);
      setStep(root, 'fit', 'complete'); setStep(root, 'construction', 'active'); setStep(root, 'color', 'locked'); setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
      focusActiveStep(root);
      saveBuild(root, session);
    }));

    $$(root, '[data-width-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) { setStatus(root, 'We could not apply that width to the Eurus selector.', 'error'); return; }
      selectButton(button, $(root, '[data-standard-width-choices]'), '[data-width-choice]');
      root.dataset.webbingWidth = button.dataset.nativeValue;
      constructionComplete(root, session);
    }));


    root.addEventListener('edg:fi-selection', event => {
      const choice = event.detail;
      root.dataset.savedFiSeries = ''; root.dataset.nativeFiSeries = ''; root.dataset.webbingWidth = ''; root.dataset.colorValue = '';
      const color = $(root, '[data-color-select]'); if (color) color.value = '';
      $$(root, '[data-color-choice]').forEach(button => { button.classList.remove('is-selected'); button.setAttribute('aria-pressed','false'); });
      setStep(root, 'construction', 'active'); setStep(root, 'color', 'locked'); setStep(root, 'addons', 'locked'); setStep(root, 'review', 'locked');
      setText(root, '[data-step-summary="construction"]', choice.modelLabel); setText(root, '[data-step-summary="color"]', '');
      choice.applied = true;
      if (!choice.value) { saveBuild(root, session); return; }
      if (!applyNative(choice.option, choice.value)) { choice.applied = false; return; }
      root.dataset.fiOption = choice.option; root.dataset.nativeFiSeries = choice.value; root.dataset.webbingWidth = choice.width;
      constructionComplete(root, session);
      document.dispatchEvent(new CustomEvent('eurus:variant:change'));
    });

    $$(root, '[data-fi-native-choice]').forEach(button => button.addEventListener('click', () => {
      if (!applyNative(button.dataset.nativeOption, button.dataset.nativeValue)) { setStatus(root, 'We could not apply that Fi configuration to the Eurus selector.', 'error'); return; }
      selectButton(button, $(root, '[data-fi-native-choices]'), '[data-fi-native-choice]');
      root.dataset.nativeFiSeries = button.dataset.nativeValue;
      if (/Series 2/i.test(button.dataset.nativeValue || '')) {
        root.dataset.webbingWidth = '';
        show($(root, '[data-fi2-width]'), true);
      } else {
        show($(root, '[data-fi2-width]'), false);
        root.dataset.webbingWidth = constructionWidth(root);
        constructionComplete(root, session);
      }
    }));

    $$(root, '[data-fi2-width-choice]').forEach(button => button.addEventListener('click', () => {
      selectButton(button, button.parentElement, '[data-fi2-width-choice]');
      root.dataset.webbingWidth = button.dataset.fi2WidthChoice;
      constructionComplete(root, session);
    }));

    $(root, '[data-color-select]').addEventListener('change', event => {
      const option = event.target.options[event.target.selectedIndex];
      if (!event.target.value || option.disabled) return;
      if (!applyNative(option.dataset.nativeOption || root.dataset.colorOption, event.target.value)) { setStatus(root, 'We could not apply that color to the Eurus selector.', 'error'); return; }
      root.dataset.colorValue = event.target.value; root.dataset.preferredColor = event.target.value;
      setText(root, '[data-step-summary="color"]', event.target.value);
      setStep(root, 'color', 'complete'); setStep(root, 'addons', 'active'); setStep(root, 'review', 'locked');
      updateReview(root); saveBuild(root, session);
    });

    $$(root, '[data-edit-step]').forEach(button => button.addEventListener('click', () => { if (!button.disabled) activateStep(root, button.dataset.editStep); }));
    $(root, '[data-add-build]').addEventListener('click', () => addBuild(root, session));
    document.addEventListener('eurus:variant:change', () => filterColors(root));
    saveBuild(root, session);
  }

  function boot(attempt) {
    const root = document.querySelector('[data-edg-arctic-builder]');
    if (!root) return;
    const session = window.EDGBuildSession;
    if (!session) { if ((attempt || 0) < 50) setTimeout(() => boot((attempt || 0) + 1), 60); return; }
    init(root, session);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(0)); else boot(0);
  document.addEventListener('shopify:section:load', () => boot(0));
})();




